import "../FeaturedListings/FeaturedListings.css";

import {useEffect, useState} from "react";

import {useLocation, useNavigate} from "react-router-dom";

import Navbar from "../../components/Navbar/Navbar";

import MenuOverlay from "../../pages/MenuOverlay/MenuOverlay";

import { deleteRent, editRent } from "../../utilities/rent-api";

export default function RentMore()
{

    const location = useLocation();
    const {rent, user} = location.state;
    const navigate = useNavigate();

    // Fill in listing state
    const [rentingState, setRentingState] = useState({
        price: rent.price,
        address: rent.address,
        beds: rent.beds,
        baths: rent.baths,
        sqft: rent.sqft,
        desc: rent.desc,
        status: rent.status,
        coverImg: rent.coverImg,
        galleryImg: [],
        mls: rent.mls,
        type: rent.type,
    });

    // Local state for form inputs
    const [formState, setFormState] = useState({ ...rentingState });

    const [error, setError] = useState("");

    // handle changes in form input fields
    function handleChange(evt) {
        const { name, value, type, files } = evt.target;
    
        if (name === "coverImg") {
            // Handle single file input for cover image
            setFormState((prevState) => ({
                ...prevState,
                [name]: files[0], // Store the single file
            }));
        } else if (name === "galleryImg") {
            // Handle multiple gallery images
            setFormState((prevState) => ({
                ...prevState,
                [evt.target.name]: [...prevState.galleryImg, ...Array.from(evt.target.files)], // Merge existing and new files
            }));
        } else {
            // Handle other input fields
            setFormState((prevState) => ({
                ...prevState,
                [name]: type === "number" ? Number(value) : value, // Convert to number if input type is "number"
            }));
        }
    
        setError(""); // Clear any existing error
    }

    // handle form submission
    async function handleSubmit( evt )
    {
        evt.preventDefault();
        try {

            // Update the main listing state
            // setListingState(formState);


            const formData = new FormData();

            // Append all fields except files
            for (const key in formState) {
                if (key !== "coverImg" && key !== "galleryImg") {
                    formData.append(key, formState[key]);
                }
            }

            // Append cover image
            if (formState.coverImg && formState.coverImg instanceof File) {
                formData.append("coverImg", formState.coverImg, formState.coverImg.name);
            }

            // Append gallery images
            if (formState.galleryImg && formState.galleryImg.length > 0) {
                formState.galleryImg.forEach((file) => {
                    // Check if the file is an instance of File
                    if (file instanceof File) {
                        formData.append("galleryImg", file, file.name); // Append each file with the same key
                    }
                    else {
                        formData.append("galleryImg", file); // Append existing URLs without the name
                    }
                });
            }

            await editRent(rent._id, formData);
            navigate('/rent');
        } catch {
            setError("Submition Failed - Please Try Again");
        }
    }

    useEffect(() => {
                window.scrollTo(0, 0);
              }, []);
        
              const deleteR = async () => {
                try {
                    const response = await deleteRent(rent._id);
                    navigate('/rent');
                } catch (error) {
                    console.error('Error deleting listing:', error);
                    alert('An error occurred while deleting the listing');
                  }
            }

    const [currentImageIndex, setCurrentImageIndex] = useState(0); // Track the current image index
    
    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === rent.galleryImg.length - 1 ? 0 : prevIndex + 1
        );
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex === 0 ? rent.galleryImg.length - 1 : prevIndex - 1
        );
    };
      
    return(
            <>
            <Navbar />
            <div className="ftListMore">
                <section className="featuredListMore">
                    <section className="featuredListMore-upper">
                        <img
                                src={rent.coverImg}
                                alt="house"
                                className="featuredListMore-left-img"
                        />
                        <div className="featuredListMore-upper-right">
                            <div className="featuredListMore-right-price">${rent.price}</div>
                            <div className="featuredListMore-right-address">{rent.address}</div>
                            <div className="featuredListMore-right-status">{rent.status}</div>
                            <div className="featuredListMore-bed-bath-sqft-type">
                                <div className="featuredListMore-beds">{rent.beds} beds • </div>
                                <div className="featuredListMore-baths">{rent.baths} baths • </div>
                                <div className="featuredListMore-sqft">{rent.sqft} sq ft • </div>
                                <div className="featuredListMore-type">{rent.type}</div>
                            </div>
                            <div className="featuredListMore-mls">MLS # {rent.mls}</div>
                        </div>
                    </section>
                    
                    <section className="featuredListMore-lower">
                        <div className="featuredListMore-desc">{rent.desc}</div>
                        {/* Gallery Carousel */}
                        {rent.galleryImg && rent.galleryImg.length > 0 && (
                                <div className="featuredList-carousel">
                                <button
                                    className="carousel-arrow carousel-arrow-left"
                                    onClick={handlePrevImage}
                                >
                                    &#8592; {/* Left arrow */}
                                </button>
                                <img
                                    src={rent.galleryImg[currentImageIndex]}
                                    alt={`Gallery ${currentImageIndex + 1}`}
                                    className="featuredList-carousel-img"
                                />
                                <button
                                    className="carousel-arrow carousel-arrow-right"
                                    onClick={handleNextImage}
                                >
                                    &#8594; {/* Right arrow */}
                                </button>
                            </div>
                        )}
                        <div className="featuredListMore-edit-link">
                            {user ?
                                <>
                                <button className="featuredList-delete" onClick={deleteR}>Delete Listing</button>
                                </>
                            : null}
                        </div>
                    </section>
                </section>
    
                {user ?
                    <>
    
                    <section className="add-ftListMore-featuredList">
                        <div className="add-featuredList-heading">Edit Featured Listing</div>
                            <form className="add-featuredList-form" onSubmit={ handleSubmit }>
                                <div className="add-featuredList-row-col-inputs">
                                    <div className="add-featuredList-price-baths-type">
                                        <div className="add-featuredList-name">
                                            <label>Edit Address</label>
                                            <input
                                                type="text"
                                                name="address"
                                                value={ formState.address }
                                                onChange={ handleChange }
                                                required
                                            />
                                        </div>
                                        <div className="add-featuredList-price">
                                        <div>Price:</div>
                                        <input
                                            type="number"
                                            name="price"
                                            value={ formState.price }
                                            onChange={ handleChange }
                                            className="add-featuredList-price-input"
                                        />
                                    </div>
    
                                    <div className="add-featuredList-baths">
                                        <div>Baths:</div>
                                        <input
                                            type="number"
                                            name="baths"
                                            value={ formState.baths }
                                            onChange={ handleChange }
                                            className="add-featuredList-baths-input"
                                        />
                                    </div>
    
                                    <div className="add-featuredList-type">
                                        <div>Type:</div>
                                        <input
                                            type="text"
                                            name="type"
                                            value={ formState.type }
                                            onChange={ handleChange }
                                            className="add-featuredList-type-input"
                                        />
                                    </div>
                                </div>
    
                                <div className="add-featuredList-sqft-beds-mls">
    
                                    <div className="add-featuredList-status">
                                        <div>Status</div>
                                        <select 
                                            name="status"
                                            value={ formState.status }
                                            onChange={ handleChange }>
                                            <option value="ACTIVE">Active</option>
                                            <option value="PENDING">Pending</option>
                                            <option value="SOLD">Sold</option>
                                        </select>
                                    </div>
    
                                    <div className="add-featuredList-sqft">
                                        <div>Square Footage:</div>
                                        <input
                                            type="number"
                                            name="sqft"
                                            value={ formState.sqft }
                                            onChange={ handleChange }
                                            className="add-featuredList-sqft-input"
                                        />
                                    </div>
    
                                    <div className="add-featuredList-beds">
                                        <div>Beds:</div>
                                        <input
                                            type="number"
                                            name="beds"
                                            value={ formState.beds }
                                            onChange={ handleChange }
                                            className="add-featuredList-beds-input"
                                        />
                                    </div>
    
                                    <div className="add-featuredList-mls">
                                        <div>MLS:</div>
                                        <input
                                            type="number"
                                            name="mls"
                                            value={ formState.mls }
                                            onChange={ handleChange }
                                            className="add-featuredList-mls-input"
                                        />
                                    </div>
                                </div>
                            </div>
    
                            <div className="add-featuredList-image-cover">
                                <div className="add-featuredList-coverImage">
                                    <div>Cover Image:</div>
                                    <input
                                        type="file"
                                        name="coverImg"
                                        onChange={ handleChange }
                                    />
                                </div>
                            </div>
    
                            <div className="add-featuredList-image-gallery">
                                <div className="add-featuredList-galleryImages">
                                    <div>Gallery Images:</div>
                                    <input
                                        type="file"
                                        name="galleryImg"
                                        multiple // Allow multiple file selection
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
    
                            <div className="add-featuredList-desc">
                                <div>Description</div>
                                <input
                                    type="text"
                                    name="desc"
                                    value={ formState.desc }
                                    onChange={ handleChange }
                                />
                            </div>
    
                            <div className="add-featuredList-button">
                                <button className="add-featuredList-submit" type="submit">Submit</button>
                            </div>
                        </form>
                        <p className="error-message">{ error }</p>
                    </section>
                    </>
                : null}
    
    
    
            </div>
            <MenuOverlay />
            </>
        )
    }